import { Component } from '@angular/core';
import { NgModule } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { TooltipModule } from "ngx-tooltip";
import {AhmService} from "./services/ahm.service";
import {noUndefined} from "@angular/compiler/src/util";
import {isUndefined} from "util";
import { TranslateService } from './services/translate.service';
import { NavigationService } from './services/navigation.service';



// interface DataPage {
//   pageNumber: number;
//   id: number;
//   title: string;
//   completed: boolean;
// }


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {

  // title = 'Alphabet of the Human Mind book series 1';
  // subtitle = 'You are the best PSY-Master in your life* (* means for your life) instruments';
  // about book
  version = 'eng';
  homePageLogo = '';
  alphabet = '';
  human = '';
  mind = '';
  subtitle = '';
  authors = '';
  // login form
  loginform = '';
  mobile = '';
  login = '';
  close = '';
  paysub = '';
  // social
  rideroButtonLink = '';
  rideroButtonImage = '';
  amazonButtonLink = '';
  amazonButtonImage = '';
  boomstarterButtonLink = '';
  boomstarterButtonImage = '';
  instagramButtonLink = '';
  instagramButtonImage = '';
  vkButtonLink = '';
  vkButtonImage = '';
  youtubeButtonLink = '';
  youtubeButtonImage = '';
  fbButtonLink = '';
  fbButtonImage = '';

  // right panel control
  changeLanguageRUColor = 'grey';
  changeLanguageENColor = 'black';

  // top menu - books
  navigationColor = 'white';
  navigationSize = 25; // size of contol elements font in pixeles
  navigationTextSize = 15;
  booksButtonMenuColor = 'white';
  aboutButtonMenuColor = 'white';
  rightButtonMenuColor = 'white';
  leftButtonMenuColor = 'white';
  centerButtonMenuColor = 'white';

  // mainPageDisplay = 'none';
  mainPageDisplay = 'block';
  loginFormDisplay = 'block';


  // TODO: fix translate by default
  constructor(private http: HttpClient, private translate: TranslateService) {

    // console.log('TranslateService', TranslateService);

    let englishVersion = true;
    let currentUrl = window.location + '';
    currentUrl = 'ru.alphabetofthehumanmind';
    // Check out domain to find out what language version of site to load
    if (
      (-1 != currentUrl.toString().indexOf('ru.alphabetofthehumanmind')) /*&&
      (-1 == currentUrl.toString().indexOf('test.ahmdev.ru'))*/
    ) {
      // console.log('set russian version');
      this.version = 'rus';
      this.changeLanguageRUColor = 'black';
      this.changeLanguageENColor = 'grey';
    } else if ((-1 !== currentUrl.toString().indexOf('en.alphabetofthehumanmind'))){
      // console.log('set english version');
      this.version = 'eng';
      this.changeLanguageRUColor = 'grey';
      this.changeLanguageENColor = 'black';
    }

    AhmService.prototype.setAppComponentLink(this);
    AhmService.prototype.version = this.version;
    // AhmService.prototype.allComponentsDefinedAndInService(this.version);
    // console.log('AhmService.prototype.translate');

    /**
     * TRANSLATE links and images (right and left panel)
     * works onload
     */
    AhmService.prototype.translate('eng'/*this.version*/);

    // translate.use('ua').then(() => {
      //console.log(translate.data);
    // });
  }

  setLang(lang: string) {
    this.translate.use(lang);
  }


  ngOnInit(): void {

    // AHM1ENG: recieving pages data into app onload
    const pagesDataArrayAHM1ENG: DataPage[] = [];
    // 'http://jsonplaceholder.typicode.com/todos'
    this.http.get('assets/data/ahm1engpages.json').subscribe(
      data => {
        for (var i = 0; i < 10000; i++) {
          if (isUndefined(<DataPage>data[i])) break;
          pagesDataArrayAHM1ENG.push(<DataPage>data[i]);
        }
      },
      error => {
        // console.log('Error in recieving pages data ahm1eng');
      },
      ()   => {
        // console.log('pagesDataArrayAHM1ENG -> ', pagesDataArrayAHM1ENG);
        // put array into ahm service
        AhmService.prototype.setPagesData(pagesDataArrayAHM1ENG, 'ahm1eng');
      }
    );

    // AHM1RUS: recieving pages data into app onload
    const pagesDataArrayAHM1RUS: DataPage[] = [];
    // 'http://jsonplaceholder.typicode.com/todos'
    this.http.get('assets/data/ahm1ruspages.json').subscribe(
      data => {
        for (var i = 0; i < 10000; i++) {
          if (isUndefined(<DataPage>data[i])) break;
          pagesDataArrayAHM1RUS.push(<DataPage>data[i]);
        }
      },
      error => {
        // console.log('Error in recieving pages data ahm1rus');
      },
      ()   => {
        // console.log('pagesDataArrayAHM1RUS -> ', pagesDataArrayAHM1ENG);
        // put array into ahm service
        AhmService.prototype.setPagesData(pagesDataArrayAHM1RUS, 'ahm1rus');
      }
    );


  }


}
